import { FormattedMessage } from 'react-intl';
import { DisclaimerTrigger } from 'routes/smart-quote/components/disclaimer';
import { trackSmartQuoteEvent } from 'routes/smart-quote/utils';

export function AvailableProducts() {
  const trackDisclaimer = () => {
    trackSmartQuoteEvent('disclaimer', 'open - quick start available product types');
  };

  return (
    <DisclaimerTrigger>
      <button
        className="btn btn-lg btn-link btn-icon-start flex-x w-100 flex-x justify-content-start"
        onClick={trackDisclaimer}
      >
        <i aria-hidden="true" className="icon icon-outlined text-secondary">
          category
        </i>
        <FormattedMessage id="productSelector.available.productTypes" defaultMessage="Available product types" />
      </button>
    </DisclaimerTrigger>
  );
}
